import styled from 'styled-components'


export const CustomContainer = styled.div`
    h1 { 
        font-weight: 700;
        font-size: 20px;
        color: #333333;
    }
`;

export const FirstGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 0.8fr;
    
    grid-column-gap: 16px;
    grid-row-gap: 16px;

    @media only screen and (max-width: 1330px) { 
        grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));
    }
`;

export const SecondGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    @media only screen and (max-width: 1200px) { 
        grid-template-columns: 1fr;
    }

`;

export const Medias = styled.div`
    min-width: 305px;
    min-height: 100%;
    /* grid-column-start: 3;
    grid-column-end: 4; */
    box-shadow: 0px 2px 8px 0px rgba(51, 51, 51, 0.15);
    border-radius: 4px;
    padding: 24px ;
    /* grid-area: box3; */
    @media only screen and (max-width: 1330px) { 
       
    }
`;


export const MediasTitle = styled.div`

    text-align: left;
    border-bottom: 1px solid #EEEEEE;
    padding: 6px;
`;

export const MediasList = styled.div`
    ul { 
        list-style: none;
        padding: 0;

        
    }

    li { 
        display: flex;
        justify-content: space-between;
        font-size: 14px;

        margin-top: 8px;


        span { 
           color: #606060;
            text-align: left;
        }
    }
`;

export const CategoryIcon = styled.em`
    color: #606060;
    font-size: 15px;
    cursor: pointer;
    margin-right: 4px;
    line-height: 0.5px;
    
`;
export const AccessesCounter = styled.span`
    font-size: 12px;
`;

export const RowCustom = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`

export const Knowledge = styled.div`
    min-height: 100%;
    box-shadow: 0px 2px 8px 0px rgba(51, 51, 51, 0.15);
    border-radius: 4px;
    padding: 24px ;
`

export const KnowledgeTitle = styled.div`
    text-align: left;
    border-bottom: 1px solid #EEEEEE;
    padding: 6px;
`

export const KnowledgeList = styled.div`
    ul{ 
        list-style: none;
        padding: 0;
    }

    li { 
        display: flex;
        justify-content: space-between;
        background: #F6F7FB;
        font-size: 14px;
        margin-top: 8px;
        border-radius: 4px;
        padding: 5px;

        span { 
           color: #606060;
            text-align: left;
        }
    }

    em { 
        font-size: 24px;
    }
`

export const FilterCharDiv = styled.div`
 box-shadow: 0px 2px 8px 0px rgba(51, 51, 51, 0.15)
`;